import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-search\"><path d=\"M46.912 490.688a443.712 443.712 0 1 1 783.488 285.44l135.424 135.36a38.4 38.4 0 0 1-54.272 54.336l-135.424-135.424A443.712 443.712 0 0 1 46.976 490.624z m443.776-366.976a366.912 366.912 0 1 0 0 733.888 366.912 366.912 0 0 0 0-733.888z\" p-id=\"4887\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol